module.exports = __webpack_public_path__ + "img/puzzle1-500.0912577e.png";